// src/constants/routes.js
// Centralized public route whitelist - single source of truth

/**
 * Default redirect path after successful login/signup
 * Can be overridden by REACT_APP_AFTER_LOGIN_PATH env variable
 */
export const AFTER_LOGIN_PATH = process.env.REACT_APP_AFTER_LOGIN_PATH || '/frogs';

export const PUBLIC_PATHS = [
  '/',
  '/about',
  '/login',
  '/signup',
  '/email-confirmation-sent',
  '/email-verified',
  '/reset-password',
  '/products',
  '/frogs',
  '/plants',
  '/geckos',
  '/aquatics',  // legacy alias → /geckos (kept until old bookmarks age out)
  '/cart',
  '/shipping-policy',
  '/faq',
  '/care-guides',
];

/**
 * Normalize a path by lowercasing, removing query/hash, and trimming trailing slash
 * @param {string} path - The path to normalize
 * @returns {string} - Normalized path
 */
export const normalizePath = (path) => {
  if (!path) return '/';

  // Remove query string and hash
  let normalized = path.split('?')[0].split('#')[0];

  // Lowercase for case-insensitive matching
  normalized = normalized.toLowerCase();

  // Remove trailing slash (except for root "/")
  if (normalized.length > 1 && normalized.endsWith('/')) {
    normalized = normalized.slice(0, -1);
  }

  return normalized;
};

/**
 * Check if a path is public (doesn't require authentication)
 * @param {string} pathname - The pathname to check (e.g., location.pathname)
 * @returns {boolean} - True if the path is public
 */
export const isPublicPath = (pathname) => {
  const normalized = normalizePath(pathname);

  // Exact match for root-level public paths
  if (PUBLIC_PATHS.includes(normalized)) {
    return true;
  }

  // Pattern matches for dynamic routes
  const publicPatterns = [
    /^\/frogs\/.+$/,                    // /frogs/:genus, /frogs/products/:productId
    /^\/care-guides\/.+$/,              // /care-guides/:speciesSlug
    /^\/reset-password\/.+\/.+$/,       // /reset-password/:uid/:token
  ];

  return publicPatterns.some(pattern => pattern.test(normalized));
};
